module.exports = "/_next/static/images/CustomSources@2x-4abaeba8e582577dde89f3ee3c1607b7.webp";